<template>
  <FunnelBreadcrumb :funnel-hash="{}" :has-shipping="false" />
  <RevContainer class="mx-auto mb-56 w-full md:w-[41.25rem]">
    <RevIllustration
      :alt="i18n(translations.title)"
      class="m-auto my-48 block"
      :height="160"
      src="/img/buyback/no-offer.svg"
      :width="160"
    />
    <header>
      <h1 class="heading-1 mb-16">
        {{ i18n(translations.title) }}
      </h1>
    </header>

    <p class="body-1 mb-32">
      {{ i18n(translations.paragraph) }}
    </p>

    <RevButton
      v-if="!isRecyclingEnabled"
      data-test="buyback-btn"
      :to="buybackHomeRoute"
      variant="secondary"
    >
      {{ i18n(translations.button) }}
    </RevButton>

    <RevInfoBlock
      v-if="isRecyclingEnabled"
      data-test="recycling-info-block"
      :icon="IconLeaf"
      :title="i18n(translations.infoBlockTitle)"
      variant="success"
    >
      <div>
        {{ i18n(translations.infoBlockParagraph) }}
      </div>
    </RevInfoBlock>
    <div v-if="isRecyclingEnabled">
      <RevButton
        class="my-32"
        data-test="recycle-btn"
        full-width="always"
        :to="recyclingRoute"
        variant="primary"
      >
        {{ i18n(translations.cta) }}
      </RevButton>

      <h3 class="heading-3">
        {{ i18n(translations.partnerTitle) }}
      </h3>

      <RecyclingPartnerBlock class="mt-16" />
    </div>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useRoute, useRuntimeConfig } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconLeaf } from '@ds/icons/IconLeaf'

import { CMS } from '~/scopes/cms/routes-names'
import { ROUTES } from '~/scopes/recycling/routes-names'

import FunnelBreadcrumb from '../components/FunnelBreadcrumb/FunnelBreadcrumb.vue'
import RecyclingPartnerBlock from '../components/RecyclingPartnerBlock/RecyclingPartnerBlock.vue'
import { useBuybackConfig } from '../config/useBuybackConfig'

import translations from './NoOffer.translations'

const i18n = useI18n()
const route = useRoute()
const { KILL_BUYBACK_RECYCLING_LINK } = useRuntimeConfig().public
const buybackConfig = useBuybackConfig()

const isRecyclingEnabled =
  !KILL_BUYBACK_RECYCLING_LINK && buybackConfig?.recyclingLink

const buybackHomeRoute = {
  name: CMS.BUYBACK,
  params: {
    ...route?.params,
    pageName: 'home',
  },
}

const recyclingRoute = {
  name: ROUTES.CATEGORY,
}
</script>
